import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionHotelPolicyBestRateNotice } from "./best-rate-notice";
import { QuestionReservationDefaultInitPeopleNum } from "./default-init-people-num";
import { QuestionIsCalendarStartFromAvailableMonth } from "./is-calendar-start-from-available-month";
import { QuestionReservationDefaultIsShowPlanIncludedPrice } from "./is-show-plan-included-price";
import { QuestionReservationDefaultIsShowRoomPriceInCalender } from "./is-show-room-price-in-calender";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationBaseSettings: HotelPolicyCategoriesAndManagerStore["reservationBaseSettings"];
};

export const QuestionReservationBaseSettings = ({ reservationBaseSettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={reservationBaseSettings}>
			<QuestionReservationDefaultInitPeopleNum />
			<QuestionReservationDefaultIsShowRoomPriceInCalender />
			<QuestionReservationDefaultIsShowPlanIncludedPrice />
			<QuestionHotelPolicyBestRateNotice />
			<QuestionIsCalendarStartFromAvailableMonth />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionReservationBaseSettings.displayName = "QuestionReservationBaseSettings";
